const deepExtend = require('deep-extend');
const q = require('queried');
const ajax = require('component-ajax');
const cookie = require('cookie-cutter');
const extend = require('xtend/mutable');

const {
  QuestionsList,
} = require('./questions');

const {
  FirstScreen,
  GameScreen,
  LastScreen,
  CollapsedScreen,
} = require('./screens');

class NewYearTest {
  constructor({ element, questions }) {
    this.element = element;

    this.initLayout();

    this.content = q('.nyt-content', this.element);

    if (this.element.classList.contains('nyt--collapsed')) {
      this.renderScreen(new CollapsedScreen());
    } else if (this.element.classList.contains('nyt--finished')) {
      this.renderScreen(new LastScreen({}));
    } else {
      this.questions = questions;

      this.questionsList = new QuestionsList(this.questions);
      this.data = {
        location: null,
        gender: null,
        answers: [],
      };

      this.step = -1;
      this.renderScreen(new FirstScreen());
    }
  }

  renderScreen(screen) {
    this.content.innerHTML = '';
    this.content.appendChild(screen.render());

    this.bindScreenEvents(screen);
  }

  bindScreenEvents(screen) {
    screen.on('answerChange', (patch) => {
      if (typeof patch === 'number') {
        // game screen answer
        //
        // we subtract number of meta questions because they affect step
        // but shouldn't affect the answers array
        const index = this.step - this.questionsList.metaQuestionsLength;
        this.data.answers[index] = patch;
      } else {
        // meta screen answer (location, gender)
        this.data = deepExtend(this.data, patch);

        const { gender } = this.data;
        if (gender) {
          this.questionsList.setGender(gender);
        }
      }
    });

    screen.on('next', () => {
      this.step += 1;

      const { ga } = window;
      if (this.step) {
        // game question
        ga('send', {
          hitType: 'event',
          eventCategory: 'new-year-quiz',
          eventAction: 'next-question',
          eventLabel: `from-question-${this.step}`,
        });
      } else {
        // first screen
        ga('send', {
          hitType: 'event',
          eventCategory: 'new-year-quiz',
          eventAction: 'begin',
        });
      }

      const nextQuestion = this.questionsList.next();
      if (nextQuestion) {
        const nextScreen = new GameScreen({
          question: nextQuestion,
          step: this.step,
          questionsLength: this.questionsList.getLength(),
        });
        this.renderScreen(nextScreen);
      } else {
        screen.renderLoadingState();

        // last question handling
        ajax({
          url: '/gifts/quiz/',
          type: 'POST',
          data: extend({}, this.data, cookie.get('csrftoken')),
          success: (resp) => {
            this.renderScreen(new LastScreen(resp));
          },
          error: () => {
            screen.renderStaticState();
            screen.renderError('Ошибка при отправке. Попробуйте ещё раз');
          },
        });
      }
    });

    screen.on('show-last-screen', () => {
      this.renderScreen(new LastScreen({}));
    });
  }

  initLayout() {
    this.element.innerHTML = '<div class="nyt-content"></div>';
  }
}

module.exports = NewYearTest;
